import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Box, Button, Grid, Typography, useMediaQuery } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import CycleCountSettingDetailModal from "./processComponent/CycleCountSettingDetailModal";
import CycleCustomModal from "../../Component/Common/ReuseableComponent/CycleCustomModal";
import HeaderComponent from "./processComponent/HeaderComponent";
import axios from "axios";
import "./cycleCountSetting.css";
import { getGlobals } from "../../Configs";
import moment from "moment";
import { fcheck_null_undefine_replace_empty } from "../../Utility/Utilitys";
import CmpModal from "../../Component/Common/ReuseableComponent/CmpModal";

const CycleCountSetting = () => {
  const uMediaQuery = useMediaQuery("(max-width:390px)");
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const xMediaQuery = useMediaQuery("(max-width:950px)");
  const aMediaQuery = useMediaQuery("(max-width:1300px)");
  const status = ["All", "Enter", "Post"];

  const [settingSummary, setSettingSummary] = useState([]);
  const [open, setOpen] = useState(false);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null); // Store full row data
  const vRdxuserInfo = useSelector((state) => state.login.value);

  const LocWithRights = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );

  const [filterState, setFilterState] = useState({
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1
    ).toISOString(),
    dateTo: new Date().toISOString(),
    location: LocWithRights.length > 0 ? LocWithRights[0]?.Uid : [],
    status: "All",
    countStatus: "All",
    varianceStatus: "All",
    finalPosting: "All",
  });

  const baseURL = getGlobals().API_BASE_URL;

  const handleLoadBtn = () => {
    getSettingSummary();
    if (vMediaQuery) {
      setOpenFilterModal(false);
    }
  };

  const handleRowClick = (params) => {
    setSelectedRow(params.row);
    setOpen(true);
  };

  const handleAddNew = () => {
    setSelectedRow({
      A_SheetId: 0,
      A_Date: new Date(),
      A_RefNo: "",
      A_Loc: LocWithRights.length > 0 ? LocWithRights[0]?.Uid : [],
      A_Narration: "",
      A_Status: "ENTER",
      A_CountStatus: "",
      A_VarianceStatus: "",
      A_FinalPosted: "",
      CreatedBy: "",
      CreatedDt: "",
    });
    setOpen(true);
  };

  const fFilter = () => {
    setOpenFilterModal(true);
  };
  const getSettingSummary = async () => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}cyclicCount/settingSummary`,
        fcheck_null_undefine_replace_empty({
          P_FromDate: moment(filterState?.dateFrom).format("MM/DD/YYYY"),
          P_ToDate: moment(filterState?.dateTo).format("MM/DD/YYYY"),
          P_Location: filterState?.location,
          P_Status: filterState?.status,
          P_UserCd: vRdxuserInfo?.UserID,
        })
      );

      if (response?.data) {
        setSettingSummary(response?.data?.recordset);
        loader.style.display = "none";
      }
    } catch (error) {
      console.error("Error fetching cycle count data:", error);
      loader.style.display = "none";
    }
  };

  useEffect(() => {
    getSettingSummary();
  }, []);

  return (
    <div className="div-container">
      <Box pt={2}>
        {vMediaQuery ? (
          <Grid container>
            <Grid item xs={6} marginTop={uMediaQuery ? 0.5 : 0}>
              <Typography
                variant={vMediaQuery ? "subtitle2" : "h6"}
                gutterBottom
                color={"primary"}
                sx={{ fontWeight: 600, mt: 0.5 }}
              >
                Physical Stock Setting
              </Typography>
            </Grid>
            <Grid item xs={3} textAlign={"right"}>
              <Button
                variant="contained"
                sx={{
                  height: "30px",
                  mt: 0.5,
                  textTransform: "capitalize",
                }}
                onClick={fFilter}
              >
                Filter
              </Button>
            </Grid>
            <Grid item xs={3} textAlign={"right"}>
              <Button
                variant="contained"
                sx={{
                  height: "30px",
                  mt: 0.5,
                  textTransform: "capitalize",
                }}
                onClick={handleAddNew}
              >
                New
              </Button>
            </Grid>
          </Grid>
        ) : (
          <>
            <Typography
              variant="h6"
              gutterBottom
              color={"primary"}
              sx={{ fontWeight: 600 }}
            >
              Physical Stock Setting
            </Typography>

            <HeaderComponent
              handleAddNew={handleAddNew}
              status={status}
              filterState={filterState}
              setFilterState={setFilterState}
              vRdxDBLocation={LocWithRights}
              handleLoadBtn={handleLoadBtn}
            />
          </>
        )}

        <Box
          sx={{
            mt: vMediaQuery ? 4 : 5,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            height: vMediaQuery ? "80vh" : xMediaQuery ? "65vh" : "72vh",
            width: "100%",
          }}
        >
          <DataGrid
            rowHeight={30}
            headerHeight={40}
            components={{
              Toolbar: GridToolbar,
            }}
            //  className="grid-table"
            rows={settingSummary ? settingSummary : ""}
            getRowId={(v) => v.A_SheetId}
            columns={[
              {
                field: "A_SheetId",
                headerName: "Sheet.ID",
                width: xMediaQuery ? 60 : 80,
              },
              {
                field: "A_Date",
                headerName: "Date",
                width: 95,
                valueFormatter: ({ value }) =>
                  moment(value).format("DD/MM/YYYY") == "Invalid date"
                    ? ""
                    : moment(value).format("DD/MM/YYYY"),
              },
              {
                field: "A_RefNo",
                headerName: "Ref.No",
                width: xMediaQuery ? 80 : 100,
                hide: true,
              },
              {
                field: "LocName",
                headerName: "Location",
                width: aMediaQuery ? 150 : 0,
                flex: aMediaQuery ? 0 : 1,
              },
              {
                field: "A_Status",
                headerName: "Status",
                width: 80,
              },
              {
                field: "A_CountStatus",
                headerName: "Count",
                width: 80,
              },
              {
                field: "A_VarianceStatus",
                headerName: "Variance",
                width: 80,
              },
              {
                field: "A_FinalPosted",
                headerName: "Adjustment",
                width: xMediaQuery ? 80 : 100,
              },
              {
                field: "A_Narration",
                headerName: "Narration",
                width: aMediaQuery ? 150 : 0,
                flex: aMediaQuery ? 0 : 1,
                hide: aMediaQuery ? true : false,
              },
              {
                field: "CreatedBy",
                headerName: "Created By",
                width: 150,
              },
              {
                field: "CreatedDt",
                headerName: "Created Date",
                width: 95,
                valueFormatter: ({ value }) =>
                  moment(value).format("DD/MM/YYYY") == "Invalid date"
                    ? ""
                    : moment(value).format("DD/MM/YYYY"),
              },
            ]}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            sx={{
              border: 1,
              borderColor: "primary.light",
               '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#0d73bb',
                    color: 'white'
                  },
            }}
            onRowClick={handleRowClick}
          />
        </Box>
        <CycleCustomModal
          open={open}
          onClose={() => {
            setOpen(false);
            getSettingSummary();
          }}
          vMediaQuery={vMediaQuery}
          xMediaQuery={xMediaQuery}
          title="Stock Setting Detail"
        >
          <CycleCountSettingDetailModal
            open={open}
            closeModal={() => {
              setOpen(false);
              getSettingSummary();
            }}
            vMediaQuery={vMediaQuery}
            uMediaQuery={uMediaQuery}
            rowData={selectedRow} // Pass full row data to modal
            xMediaQuery={xMediaQuery}
          />
        </CycleCustomModal>

        <CmpModal
          open={openFilterModal}
          onClose={() => setOpenFilterModal(false)}
          width={"95%"}
          height={"auto"}
          title="Filter"
          component={
            <HeaderComponent
              closeModal={() => setOpenFilterModal(false)}
              status={status}
              handleLoadBtn={handleLoadBtn}
              filterState={filterState}
              setFilterState={setFilterState}
              vRdxDBLocation={LocWithRights}
            />
          }
        />
      </Box>
    </div>
  );
};

export default CycleCountSetting;
